import { Injectable } from '@angular/core';
import { GatewayPaymentDataDto } from '@shared/service-proxies/service-proxies';
import { Subject, ReplaySubject, Observable } from 'rxjs';

@Injectable()
export class GatewayPaymentOrderService {

 public isPaymentSuccessfully$: Subject<boolean> = new Subject<boolean>();

 // Usar ReplaySubject con buffer de 1 para no perder eventos si el componente se suscribe después
 public isGatewayPaymentSuccessfully$: ReplaySubject<GatewayPaymentDataDto> = new ReplaySubject<GatewayPaymentDataDto>(1);

  setIsPaymentSuccessfully(isPaid: boolean): void {
   this.isPaymentSuccessfully$.next(isPaid);
  }

  setIsGatewayPaymentSuccessfully(paymentData: GatewayPaymentDataDto): void {
    console.log("GatewayPaymentOrderService - setIsGatewayPaymentSuccessfully", paymentData);
   this.isGatewayPaymentSuccessfully$.next(paymentData);
  }
}
